import React from 'react'

const CartContext = React.createContext ({
    items: [],
    totalAmountBTC: 0,
    totalAmountETH: 0,    
    addItem:(item) => {},
    removeItem:(id)=>{}

});

export default CartContext;
